function getFirstComponentChild(children) {
  if (Array.isArray(children)) {
    for (let i = 0; i < children.length; i++) {
      const c = children[i];
      if (c && (c.componentOptions || (c.isComment && c.asyncFactory))) {
        return c;
      }
    }
  }
}

function remove(arr, item) {
  if (arr.length) {
    const index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1);
    }
  }
}

function pruneCacheEntry(cache, key, keys) {
  const cached = cache[key];
  if (cached && cached.componentInstance) {
    cached.componentInstance.$destroy();
  }
  delete cache[key];
  remove(keys, key);
}

export default {
  name: 'RouteKeepAlive',
  abstract: true,

  props: {
    max: [String, Number],
    includeKeys: {
      type: Array,
      required: true,
    },
  },

  created() {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed() {
    for (const key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  watch: {
    includeKeys(newKeys) {
      const allowedKeys = new Set(newKeys);
      for (const key in this.cache) {
        if (!allowedKeys.has(key)) {
          pruneCacheEntry(this.cache, key, this.keys);
        }
      }
    },
  },

  render() {
    const slot = this.$slots.default;
    const vnode = getFirstComponentChild(slot);
    const componentOptions = vnode && vnode.componentOptions;

    if (componentOptions) {
      const { cache, keys } = this;

      // Use vnode.key (which is $route.path in MainLayout.vue) as cache key
      const key = vnode.key == null
        ? componentOptions.Ctor.cid + (componentOptions.tag ? `::${componentOptions.tag}` : '')
        : vnode.key;

      // If key is not in includeKeys, do not retrieve from cache or store in cache
      if (this.includeKeys && !this.includeKeys.includes(key)) {
        return vnode;
      }

      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // Make this key the freshest in the LRU tracker
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // Prune the oldest entry if max is exceeded
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys);
        }
      }

      vnode.data.keepAlive = true;
    }

    return vnode || (slot && slot[0]);
  },
};
